module.exports = __webpack_public_path__ + "img/img6.1f86a041.png";